import { useCallback } from 'react';

import { useGlobalAppState } from '../../../../context/GlobalAppState';
import { useCloseBag } from '../../../../hooks';
import { useReorderNavigation } from '../../../../hooks/useReorderNavigation';
import { useReorderTelemetry } from '../useReorderTelemetry';
import { getValidEventKeys, logger } from '../utils';

import type { ReorderEvent } from '../../machines/Reorder.machine';

export const useActiveBagWarning = () => {
  const { reorderMachineRef } = useGlobalAppState();
  const { existingActiveBagTelemetry } = useReorderTelemetry();
  const { navigateToActiveBagWarning } = useReorderNavigation();
  const closeBag = useCloseBag();

  return useCallback(
    (event?: ReorderEvent) => {
      logger.info('Active Bag Warning', event);

      // ─── State Machine ──────────────────────────────────────────
      reorderMachineRef.send({
        ...getValidEventKeys(event),
        type: 'ACTIVE_BAG_WARNING',
      });

      // ─── Telemetry ──────────────────────────────────────────────
      existingActiveBagTelemetry();

      // ─── Navigation ─────────────────────────────────────────────
      closeBag();
      setTimeout(navigateToActiveBagWarning);
    },
    [closeBag, existingActiveBagTelemetry, navigateToActiveBagWarning, reorderMachineRef],
  );
};
